module.exports = __webpack_public_path__ + "img/mobile-phone-off.0c5fd58d.png";